import { jsx as _jsx } from "react/jsx-runtime";
import { Collapse as AntdCollapse } from 'antd';
import styled from '../styled';
const CollapseEffect = ({ children, visibled, id, className }) => {
    return (_jsx(AntdCollapse, Object.assign({ ghost: true, bordered: false, activeKey: visibled ? '1' : undefined, className: className }, { children: _jsx(AntdCollapse.Panel, Object.assign({ header: '', id: id }, { children: children }), '1') })));
};
export default styled(CollapseEffect) `
  & .ant-collapse-header {
    display: none !important;
  }

  & .ant-collapse-content-box {
    padding: 0 !important;
  }
`;
